import { useEffect } from 'react';
import { useSelector } from 'react-redux';

export const ThemeProvider = ({ children }) => {
  const theme = useSelector((state) => state.global.theme);

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return children;
};
